import { dateValidator } from "../../../../utils/clock";
import { getPrecision } from "../../../../utils/tillHelpers";
import { message } from "antd";
import db from "../../../../database";
import * as Sentry from "@sentry/react";
import { upsertLoyaltyTransaction } from "../../../../services";
import messages from "../../../../errors/messages.en-IN.json";
import useAuthStore from "../../../../stores/useAuthStore";

export const redeemLoyality = async (paymentMethod, value, cart, setCart, setAmount, setSelectedPaymentMethod, setAuthTokens, completePayment) => {
  const tillData = useAuthStore.getState().tillData;
  let loyaltyData = await db.loyalityData.toArray();

  let updatedCart = { ...cart };
  let amount = 0;
  let conversionValue = 0;
  let redemptionValue = 0;

  if (value <= updatedCart.customer.retlLoyaltyBalance) {
    loyaltyData.forEach((loyalty) => {
      if (loyalty.loyaltylevelId === updatedCart.customer.loyaltyLevel.cwrLoyaltyLevelId) {
        loyalty.loyaltyRedemption.forEach((redeemItem) => {
          if (dateValidator(redeemItem.startDate, redeemItem.endDate) && redeemItem.minPurchase <= updatedCart.total && redeemItem.pointsRequired <= parseFloat(value)) {
            conversionValue = updatedCart.customer.retlLoyaltyBalance - parseFloat(value);
            amount = redeemItem.redemptionValue * value;
            redemptionValue = redeemItem.redemptionValue;

            if (updatedCart.total < amount) {
              value = updatedCart.total === amount ? value : parseFloat((updatedCart.total / redeemItem.redemptionValue).toFixed(getPrecision(tillData)));
            }
          }
        });
      }
    });
  }

  if (updatedCart.customer.loyaltyLevel.cwrLoyaltyLevelId && amount > 0 && amount <= updatedCart.total - updatedCart.paid) {
    if (value <= parseFloat(updatedCart.customer.retlLoyaltyBalance)) {
      updatedCart.customer.retlLoyaltyBalance = parseFloat(conversionValue.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));
      updatedCart.customer.redeemptionValue = parseFloat(redemptionValue.toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision));

      try {
        const loyaltyResponse = await upsertLoyaltyTransaction(tillData, value, updatedCart.customer.cwrCustomerId, updatedCart.referenceId);
        if (loyaltyResponse?.data?.data?.upsertLoyaltyTransaction?.status) {
          let rem = (parseInt(updatedCart.redemptionPoints) || 0) + parseFloat(value);
          updatedCart.redemptionPoints = rem;
          completePayment(paymentMethod, amount, updatedCart, setCart, setAmount, setSelectedPaymentMethod);
        }
      } catch (err) {
        message.error(`${messages.errors.loyalty.loyalty_processing_error}`);
        Sentry.captureException(err);
        Sentry.captureException(new Error("Loyalty payment Error"), {
          extra: JSON.stringify({
            csBunitId: tillData.tillAccess.csBunit.csBunitId,
            loyaltyPoints: value,
            b2cCustomerId: updatedCart.customer.cwrCustomerId,
            referenceId: updatedCart.referenceId,
          }),
        });
      }
    } else {
      message.error(`${messages.errors.loyalty.loyalty_points_exceeded}`);
    }
  } else if (amount > updatedCart.total - updatedCart.paid) {
    message.warning(`${messages.errors.loyalty.loyalty_overpayment}`);
  }
};
